// Helpers for the CVR registration lists. A CVR value is often a list of
// entries, each with a `periode` { gyldigFra, gyldigTil }. The current entry
// has no `gyldigTil`.

/** The entry with an open period, or the last entry when each period has ended. */
export function currentOf(list) {
  if (!Array.isArray(list) || list.length === 0) return null;
  return list.find((entry) => !entry?.periode?.gyldigTil) ?? list[list.length - 1];
}

/** "Claus Bergs Gade 5B, 1. tv, 5000 Odense C" from a `beliggenhedsadresse` list. */
export function currentAddress(list) {
  return formatAddress(currentOf(list));
}

/** One `beliggenhedsadresse` entry as one line. */
export function formatAddress(a) {
  if (!a) return '';
  const street = [a.vejnavn, `${a.husnummerFra ?? ''}${a.bogstavFra ?? ''}`].filter(Boolean).join(' ');
  const unit = [a.etage ? `${a.etage}.` : '', a.sidedoer ?? ''].filter(Boolean).join(' ');
  const town = [a.postnummer, a.postdistrikt].filter(Boolean).join(' ');
  return [street, unit, town].filter(Boolean).join(', ');
}
